import { Stack, Tooltip } from '@mui/material'
import React from 'react'

const ConfirmedLineupIcons = ({ confirmed, battingOrder }: { confirmed: boolean, battingOrder?: number }) => {
  if (confirmed === null) {
    return (
      <Tooltip title='Not playing' arrow>
        <Stack direction='row' alignItems='center' justifyContent='center' bgcolor='#640600' borderRadius='2px' height='18px' width='18px'>
          <BenchSVG />
        </Stack>
      </Tooltip>
    )
  } else if (confirmed === true) {
    return (
      <Tooltip title='Confirmed lineup' arrow>
        <Stack direction='row' alignItems='center' justifyContent='center' bgcolor='rgba(0, 181, 83, .6)' borderRadius='2px' height='18px' width='18px'>
          {battingOrder === 0 ? 'P' : battingOrder}
        </Stack>
      </Tooltip>
    )
  } else {
    return (
      <Tooltip title='Probable Lineup' arrow>
        <Stack direction='row' alignItems='center' justifyContent='center' bgcolor='#A90' borderRadius='2px' height='18px' width='18px'>
        {battingOrder === 0 ? 'P' : battingOrder}
        </Stack>
      </Tooltip>
    )
  }
}

export default ConfirmedLineupIcons

const BenchSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M6 8.21154C6.08718 8.21154 6.16026 8.18205 6.21924 8.12308C6.2782 8.0641 6.30769 7.99103 6.30769 7.90385C6.30769 7.81667 6.2782 7.74359 6.21924 7.68461C6.16026 7.62564 6.08718 7.59615 6 7.59615C5.91282 7.59615 5.83974 7.62564 5.78076 7.68461C5.7218 7.74359 5.69231 7.81667 5.69231 7.90385C5.69231 7.99103 5.7218 8.0641 5.78076 8.12308C5.83974 8.18205 5.91282 8.21154 6 8.21154ZM6.00034 6.73076C6.07127 6.73076 6.13061 6.7068 6.17836 6.65889C6.22612 6.61097 6.25 6.5516 6.25 6.48076V3.94231C6.25 3.87148 6.22601 3.8121 6.17803 3.76419C6.13005 3.71627 6.0706 3.69231 5.99966 3.69231C5.92873 3.69231 5.86939 3.71627 5.82164 3.76419C5.77388 3.8121 5.75 3.87148 5.75 3.94231V6.48076C5.75 6.5516 5.77399 6.61097 5.82197 6.65889C5.86995 6.7068 5.9294 6.73076 6.00034 6.73076ZM4.67211 10C4.56157 10 4.45621 9.9782 4.35604 9.93461C4.25585 9.89103 4.16955 9.83302 4.09711 9.76058L2.23943 7.90289C2.16698 7.83045 2.10897 7.74415 2.06539 7.64396C2.0218 7.54379 2 7.43843 2 7.32789V4.67211C2 4.56157 2.0218 4.45621 2.06539 4.35604C2.10897 4.25585 2.16698 4.16955 2.23943 4.09711L4.09711 2.23942C4.16955 2.16698 4.25585 2.10897 4.35604 2.06539C4.45621 2.0218 4.56157 2 4.67211 2H7.32789C7.43843 2 7.54379 2.0218 7.64396 2.06539C7.74415 2.10897 7.83045 2.16698 7.90289 2.23942L9.76058 4.09711C9.83302 4.16955 9.89103 4.25585 9.93461 4.35604C9.9782 4.45621 10 4.56157 10 4.67211V7.32789C10 7.43843 9.9782 7.54379 9.93461 7.64396C9.89103 7.74415 9.83302 7.83045 9.76058 7.90289L7.90289 9.76058C7.83045 9.83302 7.74415 9.89103 7.64396 9.93461C7.54379 9.9782 7.43843 10 7.32789 10H4.67211ZM4.55 9.5H7.45L9.5 7.45V4.55L7.45 2.5H4.55L2.5 4.55V7.45L4.55 9.5Z" fill="#FFBDC5" />
  </svg>
)